import { useState } from "react";

const faqData = [
    {
        question: "What services does Investycoons offer?",
        answer: "We specialize in real estate consulting, helping you buy, sell, and invest in residential and commercial properties in Noida and NCR. Our team provides expert guidance, ensuring you make the best property decisions.",
    },
    {
        question: "How can I find the right property through Investycoons?",
        answer: "Our team understands your requirements and budget to shortlist the best properties. We offer site visits, market insights, and end-to-end assistance to ensure a smooth buying experience.",
    },
    {
        question: "What types of properties do you deal with?",
        answer: "We deal in residential apartments, villas, commercial spaces, office buildings, and plots in prime locations of Noida and NCR.",
    },
    {
        question: "Where can we see the show flat of new projects?",
        answer: "We arrange guided site visits to show actual & sample apartment or whichever inventory is applicable in Gurugram, Noida, Mumbai, Goa, etc. You can schedule a visit through our website or contact our team, and we’ll assist you in experiencing the property firsthand.",
    },
    {
        question: "How do I get started with Investycoons.",
        answer: "Just give us a call, drop a message on our website, or visit our office in Noida. Our team will guide you through every step of your real estate journey.",
    },
];

export default function FAQ() {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };
    return (
        <div className="max-w-4xl mx-auto my-20 p-6 bg-white shadow-lg rounded-xl">
            <h2 className="text-xl sm:text-2xl md:text-3xl uppercase font-bold text-center text-gray-800 mb-6">Frequently Asked Questions</h2>
            <div className="space-y-4">
                {faqData.map((faq, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg">
                        <button
                            onClick={() => toggleFAQ(index)}
                            className="w-full flex justify-between items-center p-4 text-left text-gray-800 font-medium focus:outline-none hover:bg-gray-100 transition"
                        >
                            {faq.question}
                            <span className="text-lg">
                                {openIndex === index ? "−" : "+"}
                            </span>
                        </button>
                        <div
                            className={`overflow-hidden transition-all duration-300 ${openIndex === index ? "max-h-40 p-4 text-gray-600" : "max-h-0"
                                }`}
                        >
                            {faq.answer}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}